import {
  BabyDetail,
  BabyFruitSize,
  BabySizeSection,
  ReadmoreweekCTA,
} from './styled';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { clickedCtaEvent } from '../utils/instrumentation';
import { images } from '../../../Constants/ImageUrls';
// import { fireEvent } from "../../../Utils/useFirebase";

export default function BabySize(props) {
  const { growthData, location, currentWeek } = props;
  const router = useRouter();
  const readMoreHandler = () => {
    clickedCtaEvent('Read more this week', 'growth tracker');
    // fireEvent({
    //     category: "clicked_cta",
    //     screen_name: screen,
    //     section_name: 'growth tracker'
    // })
  };
  return (
    <BabySizeSection>
      <BabyFruitSize>
        <img src={growthData?.size_comparision_image} alt="" />
      </BabyFruitSize>
      <BabyDetail>
        <p className="size">
          Baby Size this week: <strong>{growthData?.fruit_description}</strong>
        </p>
        <p className="babyLine">{growthData?.body}</p>
        {location != 'GrowthFullPage' ? (
          <Link
            href={{
              pathname: `${router.route}/week-${currentWeek}`,
              query: router.query,
            }}
            passHref
            legacyBehavior
          >
            <ReadmoreweekCTA onClick={readMoreHandler}>
              Read more this week <img src={images.white_arrow} alt="" />
            </ReadmoreweekCTA>
          </Link>
        ) : null}
      </BabyDetail>
    </BabySizeSection>
  );
}
